import { defineStore } from 'pinia'
import { ref } from 'vue'
import { authAPI } from '@/api/auth'

export const useAuthStore = defineStore('auth', () => {
  // 状态
  const token = ref(localStorage.getItem('token') || '')
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'))

  // 操作
  function setToken(newToken) {
    token.value = newToken
    if (newToken) {
      localStorage.setItem('token', newToken)
    } else {
      localStorage.removeItem('token')
    }
  }

  function setUser(userInfo) {
    user.value = userInfo
    if (userInfo) {
      localStorage.setItem('user', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('user')
    }
  }

  async function login(credentials) {
    try {
      const response = await authAPI.login(credentials)
      // 统一响应格式：{ status: 0, message: '', data: { token: '', user: {} } }
      const loginData = response.data || response
      setToken(loginData.token)
      setUser(loginData.user)
      return response
    } catch (error) {
      throw error
    }
  }

  function logout() {
    setToken('')
    setUser(null)
  }

  function isLoggedIn() {
    return !!token.value
  }

  return {
    token,
    user,
    login,
    logout,
    isLoggedIn,
    setToken,
    setUser
  }
})
